var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", { staticClass: "level" }, [
          _c("div", { staticClass: "level-left" }, [
            _c(
              "div",
              { staticClass: "level-item buttons" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-info", "icon-left": "plus" },
                    on: {
                      click: function ($event) {
                        _vm.creatingReport = true
                      },
                    },
                  },
                  [_vm._v(" New ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-info", "icon-left": "plus" },
                    on: {
                      click: function ($event) {
                        _vm.verifReport = true
                      },
                    },
                  },
                  [_vm._v(" Stock validation ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-info", "icon-left": "plus" },
                    on: {
                      click: function ($event) {
                        _vm.createFifoReport = true
                      },
                    },
                  },
                  [_vm._v(" FIFO Report ")]
                ),
              ],
              1
            ),
            _vm.creatingReport ? _c("div") : _vm._e(),
          ]),
          _c("div", { staticClass: "level-right" }, [
            _c(
              "div",
              { staticClass: "level-item" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      "icon-left": "refresh",
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                    },
                    on: { click: () => _vm.refresh() },
                  },
                  [_vm._v(" Refresh ")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-full" },
            [
              _c("b-loading", {
                attrs: { "is-full-page": false },
                model: {
                  value: _vm.isLoading,
                  callback: function ($$v) {
                    _vm.isLoading = $$v
                  },
                  expression: "isLoading",
                },
              }),
              _c("ag-grid-vue", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "600px" },
                attrs: {
                  "row-data": _vm.reports,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                  "row-selection": "multiple",
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "b-modal",
          {
            attrs: {
              active: _vm.creatingReport,
              scroll: "keep",
              "has-modal-card": "",
            },
            on: {
              "update:active": function ($event) {
                _vm.creatingReport = $event
              },
            },
          },
          [
            _c("ReportForm", {
              attrs: {
                reports: _vm.fullReports,
                "extended-reports": _vm.reports,
                customers: _vm.customers,
              },
              on: { submit: _vm.generateReport },
            }),
          ],
          1
        ),
        _c(
          "b-modal",
          {
            attrs: {
              active: _vm.createFifoReport,
              scroll: "keep",
              "has-modal-card": "",
            },
            on: {
              "update:active": function ($event) {
                _vm.createFifoReport = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-card",
                staticStyle: { "min-height": "550px" },
              },
              [
                _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(" Create FIFO Report "),
                  ]),
                  _c("button", {
                    staticClass: "delete",
                    attrs: { "aria-label": "close" },
                    on: {
                      click: function ($event) {
                        _vm.createFifoReport = false
                      },
                    },
                  }),
                ]),
                _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [
                    _c(
                      "b-field",
                      [
                        _c("multiselect", {
                          staticStyle: { "min-width": "400px" },
                          attrs: {
                            options: _vm.customers,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick sold to...",
                            "custom-label": (obj) => obj.id + " - " + obj.name,
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.newFifoReport.soldTo,
                            callback: function ($$v) {
                              _vm.$set(_vm.newFifoReport, "soldTo", $$v)
                            },
                            expression: "newFifoReport.soldTo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c("b-datepicker", {
                          attrs: {
                            name: "date",
                            icon: "calendar-alt",
                            placeholder: "End date",
                            "date-formatter": (date) =>
                              _vm.$dayjs(date).format("DD/MM/YYYY"),
                          },
                          model: {
                            value: _vm.newFifoReport.endDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.newFifoReport, "endDate", $$v)
                            },
                            expression: "newFifoReport.endDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-radio",
                          {
                            attrs: { "native-value": "DMC" },
                            model: {
                              value: _vm.newFifoReport.travelType,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFifoReport, "travelType", $$v)
                              },
                              expression: "newFifoReport.travelType",
                            },
                          },
                          [_vm._v(" Domestic ")]
                        ),
                        _c(
                          "b-radio",
                          {
                            attrs: { "native-value": "ORS" },
                            model: {
                              value: _vm.newFifoReport.travelType,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFifoReport, "travelType", $$v)
                              },
                              expression: "newFifoReport.travelType",
                            },
                          },
                          [_vm._v(" Oversea ")]
                        ),
                        _c(
                          "b-radio",
                          {
                            attrs: { "native-value": "ALL" },
                            model: {
                              value: _vm.newFifoReport.travelType,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFifoReport, "travelType", $$v)
                              },
                              expression: "newFifoReport.travelType",
                            },
                          },
                          [_vm._v(" All ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-switch",
                          {
                            attrs: {
                              type: "is-primary",
                              "true-value": 1,
                              "false-value": 0,
                            },
                            model: {
                              value: _vm.newFifoReport.typeSHI,
                              callback: function ($$v) {
                                _vm.$set(_vm.newFifoReport, "typeSHI", $$v)
                              },
                              expression: "newFifoReport.typeSHI",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.newFifoReport.typeSHI === 1
                                    ? "All shippings"
                                    : "Direct shippings only"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("footer", { staticClass: "modal-card-foot" }, [
                  _c(
                    "div",
                    { staticClass: "is-flex is-align-content-center ml-auto" },
                    [
                      _c(
                        "b-checkbox",
                        {
                          staticClass: "mr-5",
                          model: {
                            value: _vm.isTest,
                            callback: function ($$v) {
                              _vm.isTest = $$v
                            },
                            expression: "isTest",
                          },
                        },
                        [_vm._v(" Test ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: _vm.isTest ? "is-primary" : "is-info",
                            "icon-left": _vm.isTest ? "vial" : "play",
                            disabled:
                              !_vm.newFifoReport.soldTo ||
                              !_vm.newFifoReport.endDate,
                          },
                          on: { click: _vm.generateFifoReport },
                        },
                        [_vm._v(" Generate ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        ),
        _c(
          "b-modal",
          {
            attrs: {
              active: _vm.verifReport,
              scroll: "keep",
              "has-modal-card": "",
            },
            on: {
              "update:active": function ($event) {
                _vm.verifReport = $event
              },
            },
          },
          [
            _c("ReturnData", {
              attrs: { customers: _vm.customers },
              on: { submit: _vm.sendData },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }